import { ILifeRule } from "./ILifeRule";

export class LiveCellWithTwoOrThreeNeighborsRule implements ILifeRule {
  canHandle = (isAlive: boolean): boolean => isAlive === true;

  shouldLive(numberOfNeighbors: number): boolean {
    return numberOfNeighbors === 2 || numberOfNeighbors === 3;
  }
}
